import axios from 'axios';
import { API } from '../../lib/api/api';

export const getSuccessfulPosts = async (auth0UserId: string) => {
	try {
		return await axios.get(
			`${API}calendar/getSuccessfulPosts?auth0UserId=${auth0UserId}`
		);
	} catch (e) {
		return {
			error: e,
			status: 'error',
			statusText: 'There was a problem retrieving your successful posts.',
			data: e
		};
	}
};
